import { newsItems } from '@/mocks/news';
import { serviceItems } from '@/mocks/services';
import { entertainmentItems } from '@/mocks/entertainment';
import { categoryMetaList } from '@/mocks/site';
import type { CategoryMeta, ContentItem, ContentType } from '@/types/content';

export const allItems: ContentItem[] = [
  ...(newsItems as ContentItem[]),
  ...(serviceItems as ContentItem[]),
  ...(entertainmentItems as ContentItem[]),
];

export function getCategoryMeta(slug: string): CategoryMeta | undefined {
  return categoryMetaList.find((c) => c.slug === slug) as CategoryMeta | undefined;
}

export function getItemsByType(type: ContentType): ContentItem[] {
  return allItems.filter((item) => item.type === type);
}

export function getItemsByCategory(category: string): ContentItem[] {
  if (!category || category === 'all') return allItems;
  return allItems.filter((item) => item.category === category);
}

export function getItemById(type: string, id: string): ContentItem | undefined {
  return allItems.find((item) => item.type === type && item.id === id);
}

export function getDetailPath(item: ContentItem): string {
  return `/detail/${item.type}/${item.id}`;
}

export function getCategoryPath(slug: string): string {
  return `/category/${slug}`;
}

export function sortByTime(items: ContentItem[], order: 'desc' | 'asc' = 'desc'): ContentItem[] {
  const sorted = [...items].sort((a, b) => {
    const ta = new Date(a.publishTime.replace(/-/g, '/')).getTime();
    const tb = new Date(b.publishTime.replace(/-/g, '/')).getTime();
    return order === 'desc' ? tb - ta : ta - tb;
  });
  return sorted;
}

export function filterBySubCategory(items: ContentItem[], sub: string): ContentItem[] {
  if (!sub || sub === '全部') return items;
  return items.filter((item) => item.subCategory === sub);
}

export function searchItems(query: string): ContentItem[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return allItems.filter((item) => {
    const haystack = [item.title, item.summary, item.subCategory, item.category, ...(item.tags || [])]
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function getRelated(item: ContentItem, limit = 4): ContentItem[] {
  const sameCategory = allItems.filter(
    (i) => i.id !== item.id && i.category === item.category,
  );
  const sameSub = sameCategory.filter((i) => i.subCategory === item.subCategory);
  const rest = sameCategory.filter((i) => i.subCategory !== item.subCategory);
  return [...sortByTime(sameSub), ...sortByTime(rest)].slice(0, limit);
}

export function getLatest(limit = 5): ContentItem[] {
  return sortByTime(allItems).slice(0, limit);
}

export function formatViews(views?: number): string {
  if (!views) return '—';
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}